import { FormikProps } from 'formik';
import { isNil, path } from 'lodash/fp';

export function arrayInputValue(valuePath: string, formikProps: FormikProps<object>): string[] {
    const values: any[] = path(valuePath, formikProps.values);
    return isNil(values) ? [] : values.map(value => '' + value);
}
